module.exports = __webpack_public_path__ + "static/media/product_information_active.57ea7b08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/product_information_active.svg
// module id = 1095
// module chunks = 36